import React from "react";
import { cn } from "@/lib/utils";

interface ResponsiveProperties {
  sm?: { size?: string };
  md?: ResponsiveProperties["sm"];
  lg?: ResponsiveProperties["sm"];
}

interface SpacerProperties
  extends ResponsiveProperties,
    React.ComponentPropsWithRef<"div"> {
  size?: string;
  direction?: "vertical" | "horizontal";
}

const Spacer = React.forwardRef<HTMLDivElement, SpacerProperties>(
  (
    {
      size = "h-4",
      direction = "vertical",
      sm,
      md,
      lg,
      className = "",
      ...props
    },
    ref,
  ) => {
    const spacerClasses = cn(
      direction === "vertical" ? size : size.replace("h-", "w-"),
      className,
      sm?.size &&
        `sm:${direction === "vertical" ? sm.size : sm.size.replace("h-", "w-")}`,
      md?.size &&
        `md:${direction === "vertical" ? md.size : md.size.replace("h-", "w-")}`,
      lg?.size &&
        `lg:${direction === "vertical" ? lg.size : lg.size.replace("h-", "w-")}`,
    );

    return (
      <div ref={ref} className={spacerClasses} {...props} aria-hidden="true" />
    );
  },
);

Spacer.displayName = "Spacer";

export default Spacer;
